/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioElementType = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ForesightScenarioElementType model module.
   * @module model/ForesightScenarioElementType
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForesightScenarioElementType</code>.
   * @alias module:model/ForesightScenarioElementType
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>ForesightScenarioElementType</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForesightScenarioElementType} obj Optional instance to populate.
   * @return {module:model/ForesightScenarioElementType} The populated <code>ForesightScenarioElementType</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ScenarioID')) {
        obj['ScenarioID'] = ApiClient.convertToType(data['ScenarioID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('BalanceTargetIndicatorID')) {
        obj['BalanceTargetIndicatorID'] = ApiClient.convertToType(data['BalanceTargetIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowCalculationTypeID')) {
        obj['CashflowCalculationTypeID'] = ApiClient.convertToType(data['CashflowCalculationTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('AffectsCashflow')) {
        obj['AffectsCashflow'] = ApiClient.convertToType(data['AffectsCashflow'], 'Boolean');
      }
      if (data.hasOwnProperty('IncludedInSalesMargin')) {
        obj['IncludedInSalesMargin'] = ApiClient.convertToType(data['IncludedInSalesMargin'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ScenarioID
   * @default 0
   */
  exports.prototype['ScenarioID'] = 0;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} BalanceTargetIndicatorID
   */
  exports.prototype['BalanceTargetIndicatorID'] = undefined;
  /**
   * @member {Integer} CashflowCalculationTypeID
   * @default 0
   */
  exports.prototype['CashflowCalculationTypeID'] = 0;
  /**
   * @member {Boolean} AffectsCashflow
   * @default false
   */
  exports.prototype['AffectsCashflow'] = false;
  /**
   * @member {Boolean} IncludedInSalesMargin
   * @default false
   */
  exports.prototype['IncludedInSalesMargin'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


